import script from "./AppBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBanner.vue?vue&type=script&setup=true&lang=js"

import "./AppBanner.vue?vue&type=style&index=0&id=90d027a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90d027a4"]])

export default __exports__